import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

import { JanelaAtualizacaoInformacoes } from './janelas-atualizacao-informacoes.model';

export class AtualizacaoInformacoesRiscoOperacao extends BaseEntity {

	public cnpjAgenteFinanceiro: string;
	
	public riscoOperacao: string;
	
	public liquidada: string;
	
	public idOperacaoAgente: string;
	
	public sistemaCobranca: string;
	
	public contratoCobranca: number;

	public dataEnvio: Date;

	public idOperacao:number;

	public statusProtocolo: string;

	public tipoProtocolo:string;
}

export class JanelaAtualizacaoInformacoesRisco extends JanelaAtualizacaoInformacoes {
}

export class SaidaAtualizacaoInformacoesOperacaoDTO {
	public idOperacaoAgenteCreditoLivre: string;

	public sistemaRepasse: string;
	
	public contratoRepasse: string;

	public riscoOperacao?: string;
	
	public liquidada?: string;

	public cnpjAgenteFinanceiro?: string;
}

export class SaidaLoteAtualizacaoInformacoesOperacaoDTO {
	public operacoes: SaidaAtualizacaoInformacoesOperacaoDTO[];
	public dataHoraExecucao: Date;
}